var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _rect, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCuvetteRackShort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 397,
    height: 103,
    viewBox: "0 0 397 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4478 75H397L366.552 91H0L30.4478 75Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0312 79H59L45.875 86H24L36.0312 79Z",
    fill: "#999999"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M176.031 79H199L185.875 86H164L176.031 79Z",
    fill: "#999999"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M106.031 79H129L115.875 86H94L106.031 79Z",
    fill: "#999999"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M246.031 79H269L255.875 86H234L246.031 79Z",
    fill: "#999999"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M316.031 79H339L325.875 86H304L316.031 79Z",
    fill: "#999999"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0312 79H94L80.875 86H59L71.0312 79Z",
    fill: "#999999"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M211.031 79H234L220.875 86H199L211.031 79Z",
    fill: "#999999"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M141.031 79H164L150.875 86H129L141.031 79Z",
    fill: "#999999"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M281.031 79H304L290.875 86H269L281.031 79Z",
    fill: "#999999"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M351.031 79H374L360.875 86H339L351.031 79Z",
    fill: "#999999"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 91,
    width: 366,
    height: 12,
    fill: "#EEEEEE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M366 91L396.849 75V101L366 103V91Z",
    fill: "#EEEEEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCuvetteRackShort);
export default __webpack_public_path__ + "static/media/cuvette_rack_short.0b50222ec2f8f22d1c214518ba030680.svg";
export { ForwardRef as ReactComponent };